import { __awaiter } from "tslib";
import React from 'react';
import { File, Lock } from 'react-feather';
import ReactPaginate from 'react-paginate';
import { BACKEND_URL, GistPrivacy } from '../../constants';
import LoginConditional from '../login-conditional';
import './index.css';
class GistSelectWidget extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            loaded: false,
            personalGist: [],
            pages: {},
            loading: true,
            selected: {
                gist: null,
                file: null,
            },
        };
    }
    componentDidMount() {
        this.handlePageChange({ selected: 0 });
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAuthenticated !== prevProps.isAuthenticated) {
            this.setState({
                currentPage: 0,
                loading: true,
            }, () => {
                this.handlePageChange({ selected: this.state.currentPage });
            });
        }
        if (this.props.private !== prevProps.private) {
            this.setState({
                currentPage: 0,
                loading: true,
            }, () => {
                this.handlePageChange({ selected: this.state.currentPage });
            });
        }
    }
    handlePageChange(page) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.loading) {
                this.setState({
                    loading: false,
                }, () => __awaiter(this, void 0, void 0, function* () {
                    let response;
                    if (page.selected === 0) {
                        response = yield fetch(`${BACKEND_URL}gists/user?cursor=init&privacy=${this.props.private}`, {
                            credentials: 'include',
                            method: 'get',
                        });
                    }
                    else {
                        response = yield fetch(`${BACKEND_URL}gists/user?cursor=${this.state.pages[page.selected]}&privacy=${this.props.private}`, {
                            credentials: 'include',
                            method: 'get',
                        });
                    }
                    const data = yield response.json();
                    if (Array.isArray(data.data)) {
                        this.setState({
                            currentPage: page.selected,
                            loaded: true,
                            pages: page.selected === 0 ? data.cursors : this.state.pages,
                            loading: true,
                            personalGist: data.data,
                        });
                    }
                    else {
                        this.props.receiveCurrentUser(data.isAuthenticated);
                    }
                }));
            }
        });
    }
    render() {
        return (React.createElement(LoginConditional, null, this.state.loaded ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "privacy-toggle" },
                React.createElement("input", { type: "checkbox", name: "privacy", id: "privacy", checked: this.props.private === GistPrivacy.ALL, onChange: this.props.toggleGistPrivacy }),
                React.createElement("label", { htmlFor: "privacy" }, "Show private gists")),
            this.state.personalGist.length > 0 ? (React.createElement(React.Fragment, null,
                Object.keys(this.state.pages).length > 1 && (React.createElement(ReactPaginate, { previousLabel: '<', nextLabel: '>', breakClassName: 'break', containerClassName: 'pagination', activeClassName: 'active', pageCount: Object.keys(this.state.pages).length, onPageChange: this.handlePageChange.bind(this), forcePage: this.state.currentPage, marginPagesDisplayed: 2, pageRangeDisplayed: 2 })),
                React.createElement("div", { className: `gist-wrapper ${!this.state.loading && 'loading'}` }, this.state.personalGist.map((gist) => (React.createElement("div", { key: gist.name, className: `gist-container ${this.state.selected.gist === gist.name && 'gist-active'}` },
                    React.createElement("div", { className: "personal-gist-description" },
                        gist.isPublic ? (React.createElement(File, { width: "14", height: "14" })) : (React.createElement(Lock, { width: "14", height: "14", fill: "#FDD300" })),
                        React.createElement("span", { className: `text ${gist.title ? '' : 'play-down'}` }, gist.title ? gist.title : 'No description provided')),
                    React.createElement("div", { className: "personal-gist-files" }, gist.spec.map((spec, index) => (React.createElement("div", { key: index, className: "file" },
                        React.createElement("div", { className: "arrow" }),
                        React.createElement("div", { className: `filename ${this.state.selected.file === spec.name &&
                                this.state.selected.gist === gist.name &&
                                'file-active'}`, key: spec.name, onClick: () => {
                                this.props.selectGist(gist.name, spec.name, spec.previewUrl);
                                this.setState({
                                    selected: {
                                        gist: gist.name,
                                        file: spec.name,
                                    },
                                });
                            } }, spec.name))))))))))) : (React.createElement(React.Fragment, null, "You have no Vega or Vega-Lite compatible gists.")))) : (React.createElement("div", { className: "loader-container" },
            React.createElement("span", null, "Loading your GISTS...")))));
    }
}
export default GistSelectWidget;
